import React, { createContext, useState, useEffect } from "react";

// 创建Context
export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [data, setData] = useState(null);

  // 模拟访问后台获取数据
  useEffect(() => {
    fetch("/data.json")  // 这里换成你的后台接口
      .then(res => res.json())
      .then(res => setData(res))
      .catch(err => console.error(err));
  }, []);

  return (
    <AppContext.Provider value={{ data, setData }}>
      {children}
    </AppContext.Provider>
  );
};